import { useCallback } from "react"

import type { PaidPlan, PlanInterval } from "@productlane/lib/src/browser"

import { toast } from "@/components/toast"
import { api } from "@/lib/api"

/** Starts the 7-day trial and reloads onto the page the server sends back. */
export function useStartTrial({
	plan = "pro",
	interval = "monthly",
}: { plan?: PaidPlan; interval?: PlanInterval } = {}) {
	const mutation = api.workspace.createTrialSubscription.useMutation({
		onError: (error) => {
			toast.error({
				title: "Couldn't start your trial",
				description: error.message,
			})
		},
	})

	const startTrial = useCallback(async () => {
		try {
			const destination = await mutation.mutateAsync({ plan, interval })
			if (destination) location.href = destination
		} catch {
			return
		}
	}, [mutation, plan, interval])

	return { startTrial, isStartingTrial: mutation.isLoading }
}
